<template>
  <div>
    <base-screen>
      <el-form :inline="true" :model="param" label-position="left"
               ref="screenForm"
               @keydown.native.enter="searchSubmit"
               @submit.native.prevent>
        <el-form-item label="订单号：">
          <el-input v-model="param.orderNo" placeholder="订单号"></el-input>
        </el-form-item>
        <el-form-item label="是否处理：">
          <el-select v-model="param.handleFlag" placeholder="请选择是否处理">
            <el-option label="未处理" value="0"></el-option>
            <el-option label="已处理" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="btn-screen" type="primary" @click="searchSubmit">查询</el-button>
          <el-button type="text" @click="resetSearchSubmit">重置</el-button>
        </el-form-item>
      </el-form>
    </base-screen>
    <div class="page-box">
      <el-table
        :data="tableData"
        v-loading="tableDataLoading">
        <el-table-column
          prop="orderNo"
          label="订单编号"
          width="200">
        </el-table-column>
        <el-table-column
          prop="name"
          label="客户名称"
          width="150">
          <div class="link"
               slot-scope="{row}"
               @click="openDialogDetail(row)">
            {{ row.name }}
          </div>
        </el-table-column>
        <el-table-column
          prop="phone"
          label="联系方式"
          width="150">
        </el-table-column>
        <el-table-column
          prop="serviceName"
          label="预约服务"
          width="200">
        </el-table-column>
        <el-table-column
          prop="orderTime"
          label="预约时间"
          width="180">
        </el-table-column>
        <el-table-column
          prop="handleFlag"
          :formatter="handleFlagInfo"
          label="是否处理">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="140">
          <template slot-scope="{row}">
            <el-button v-pms="'handle'" v-show="!row.handleFlag" class="link" @click="openDialog(row)" type="text">处理</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.pageNum"
        :page-sizes="[10, 15, 20]"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total">
      </el-pagination>

      <el-dialog
        title="处理投诉"
        :visible.sync="dialogFormVisible"
        :modal="false">
        <el-form :model="form">
          <el-form-item label="投诉内容：" label-width="120">
            <el-input type="textarea" class="content" :readonly="true" v-model="content"></el-input>
          </el-form-item>
          <el-form-item label="投诉图片：" label-width="120">
            <div v-show="item" class="inline" :key="item" v-for="item in imgsList">
              <img  @click="openBigImg(imgUrl + item)" width="100px" height="100px" :src="imgUrl + item">
            </div>
          </el-form-item>
          <el-form-item label="处理内容：" label-width="120">
            <el-input type="textarea"  class="handleContent" v-model="form.handleContent"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="handelOrder()">处 理</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="处理详情"
        :visible.sync="dialogFormVisibleDetail"
        :modal="false">
        <el-form :model="form">
          <el-form-item label="投诉内容：" label-width="120">
            <el-input type="textarea" class="content" :readonly="true" v-model="content"></el-input>
          </el-form-item>
          <el-form-item label="投诉图片：" label-width="120">
            <div v-show="item" class="inline" :key="item" v-for="item in imgsList">
              <img @click="openBigImg(imgUrl + item)" width="100px" height="100px" :src="imgUrl + item">
            </div>
          </el-form-item>
          <el-form-item label="处理内容：" label-width="120">
            <el-input type="textarea"  :readonly="true" class="content" v-model="form.handleContent"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisibleDetail = false">关 闭</el-button>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="dialogVisible" :modal="false">
        <img width="100%" :src="dialogImageUrl">
      </el-dialog>

    </div>
  </div>
</template>

<script>
import {order} from '../../api'
import {getSession} from '../../utils/session'
import {ORG_CODE} from '../../constants'

export default {
  name: 'OrderComplainList',
  props: {},
  data () {
    return {
      dialogFormVisible: false,
      dialogFormVisibleDetail: false,
      dialogVisible: false,
      dialogImageUrl: '',
      imgsList: '',
      content: '',
      orderNo: '',
      tableData: [],
      imgUrl: process.env.VUE_APP_IMG,
      page: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pages: 0
      },
      param: {
        orgCode: getSession(ORG_CODE),
        title: '',
        handleFlag: ''
      },
      tableDataLoading: false,
      form: {
        complainId: '',
        handleContent: '',
        content: '',
        memberId: ''
      }
    }
  },
  created () {
    this.getTableData()
  },
  methods: {
    async getTableData () {
      this.tableDataLoading = true
      let {data, page} = await order.getOrderComplainListPage({
        param: this.param,
        page: this.page
      })
      this.tableDataLoading = false
      this.tableData = data
      this.page = page
    },
    async handelOrder () {
      this.$confirm(`确定处理订单号:【${this.orderNo}】的投诉么?`, '系统提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        callback: async (action, instance) => {
          if (action === 'confirm') {
            if (!this.form.handleContent) {
              this.$message({
                type: 'info',
                message: '请填写处理内容'
              })
              return
            }
            let {code, msg} = await order.updateOrderComplain(this.form)
            if (code === 0) {
              this.dialogFormVisible = false
              this.getTableData()
            } else {
              this.$message({
                type: 'error',
                message: msg || '处理失败'
              })
            }
          }
        }
      })
    },
    openDialog (row) {
      this.form = {}
      this.content = row.content
      this.form.content = row.content
      this.form.memberId = row.memberId
      this.orderNo = row.orderNo
      this.form.complainId = row.complainId
      this.imgsList = row.imgs.split(',')
      this.dialogFormVisible = true
    },
    openDialogDetail (row) {
      this.form = {}
      this.content = row.content
      this.form.content = row.content
      this.form.memberId = row.memberId
      this.orderNo = row.orderNo
      this.form.complainId = row.complainId
      this.form.handleContent = row.handleContent
      this.imgsList = row.imgs.split(',')
      this.dialogFormVisibleDetail = true
    },
    openBigImg (url) {
      this.dialogImageUrl = url
      this.dialogVisible = true
    },
    handleSizeChange (val) {
      this.page.pageSize = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.page.pageNum = val
      this.getTableData()
    },
    searchSubmit () {
      this.page.pageNum = 1
      this.getTableData()
    },
    resetSearchSubmit () {
      this.$refs.screenForm.resetFields()
      this.param.orderNo = ''
      this.param.handleFlag = ''
      this.getTableData()
    },
    handleFlagInfo (row) {
      return row.handleFlag ? '已处理' : '未处理'
    }
  }

}
</script>
<style lang="scss" scoped>
  /deep/.el-form {
    .el-form-item {
      .el-form-item__content {
         .handleContent{
          .el-textarea__inner {
            resize: none;
          }
        }
        .content {
          .el-textarea__inner {
            border: none;
            resize: none;
          }
        }
        .inline {
          display: inline;
        }
      }
    }
  }
</style>
